import { LOCATION_CHANGE } from 'connected-react-router'
import {
  PREPARE_WEB_AUTHN_REGISTRATION,
  PREPARE_WEB_AUTHN_REGISTRATION_FAILED,
  REGISTER_WEB_AUTHN,
  REGISTER_WEB_AUTHN_SUCCEEDED,
  REGISTER_WEB_AUTHN_FAILED,
  FINISH_WEB_AUTHN_REGISTRATION,
  FINISH_WEB_AUTHN_REGISTRATION_SUCCEEDED,
  FINISH_WEB_AUTHN_REGISTRATION_FAILED
} from '../constants/action.types'
import * as MFASetupSteps from '../constants/mfa.setup.steps'

const initialState = {
  step: MFASetupSteps.START_REGISTRATION,
  isFromSettings: false,
  errorCode: null,
  isProcessing: false,
  registrationData: null,
  credential: null
}

export default (
  state = initialState,
  { type, payload: { errorCode, credential, registrationData } = {} }
) => {
  const newState = {
    [LOCATION_CHANGE]: initialState,
    [PREPARE_WEB_AUTHN_REGISTRATION]: {
      isProcessing: true,
      disabledForm: true,
      errorCode: null
    },
    [PREPARE_WEB_AUTHN_REGISTRATION_FAILED]: { errorCode },
    [REGISTER_WEB_AUTHN]: {
      step: MFASetupSteps.REGISTER,
      registrationData: registrationData || state.registrationData,
      errorCode: null
    },
    [REGISTER_WEB_AUTHN_SUCCEEDED]: { credential },
    [REGISTER_WEB_AUTHN_FAILED]: { errorCode, credential: null },
    [FINISH_WEB_AUTHN_REGISTRATION]: { isProcessing: true },
    [FINISH_WEB_AUTHN_REGISTRATION_SUCCEEDED]: {
      step: MFASetupSteps.REGISTRATION_COMPLETE
    },
    [FINISH_WEB_AUTHN_REGISTRATION_FAILED]: { errorCode: errorCode }
  }[type]

  return { ...state, isProcessing: false, ...newState }
}
